export default __webpack_public_path__ + "static/management-869381ca762e5f388947175a0f9d1b1a.jpg";